import { AxiosRequestConfig } from 'axios';

export const authHeader = (): AxiosRequestConfig | undefined => {
  const token = localStorage.getItem('token');
  if (!token) return undefined;

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};
